var React = require('react');

function CheckmarkCircleOutline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"id":"defs841","key":0}),React.createElement("path",{"id":"path833","d":"M -2,-2 H 22 V 22 H -2 Z","fill":"none","key":1}),React.createElement("path",{"id":"path835","d":"M 10,0 C 4.48,0 0,4.48 0,10 0,15.52 4.48,20 10,20 15.52,20 20,15.52 20,10 20,4.48 15.52,0 10,0 Z m 0,18 C 5.59,18 2,14.41 2,10 2,5.59 5.59,2 10,2 c 4.41,0 8,3.59 8,8 0,4.41 -3.59,8 -8,8 z M 14.59,5.58 8,12.17 5.41,9.59 4,11 8,15 16,7 Z","key":2})]);
}

CheckmarkCircleOutline.defaultProps = {"id":"svg837","version":"1.1","viewBox":"0 0 20 20","height":"20","width":"20"};

module.exports = CheckmarkCircleOutline;

CheckmarkCircleOutline.default = CheckmarkCircleOutline;
